import "./style.css"; 
const PageNotFind = ()=>{
    return(
        <>
        </>
    )
}
export default PageNotFind;